<template>
  <div class="tigan-title">
    <span>{{ index + 1 }}.&nbsp;</span>{{ topic.tag.name }}
  </div>
</template>
<script>
export default {
  props: {
    topic: Object,
    index: Number
  }
}
</script>
<style lang="less" scoped>
 .tigan-title {
    position: relative;
    padding: 12px 0;
    margin: 0 14px 0 34px;
    font-weight: 700;
    font-size: 16px;
    color: #505873;
    span {
      position: absolute;
      transform: translateX(-100%);
    }
  }
</style>